import { defaultApiClient } from "../libs";

export const process = async (client) => {
  return await defaultApiClient.post(`/api/v1/feedback/web`, {
    ...client.get('environment'),
  }, {
    headers: {
      'X-Client-Id': client.get('clientId'),
      'X-User-Id': client.get('userId'),
      'X-Service-Id': client.get('serviceId'),
    }
  })
}
